<div class="content">
  <glxy-alert type="info">
    {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_ZONE_EXPLANATION_1' | translate }}
    <a [routerLink]="'settings'">{{ 'AUTOMATIONS.SETTINGS.CONFIGURATION' | translate }}</a>
    {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_ZONE_EXPLANATION_2' | translate }}
  </glxy-alert>
  <form [formGroup]="form">
    <!-- Wait until -->
    <glxy-form-field>
      <glxy-label
        ><strong>{{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.WAIT_UNTIL' | translate }}</strong></glxy-label
      >
      <div>
        <mat-checkbox formControlName="waitUntilEnabled">
          {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.AMOUNT_OF_TIME' | translate }}
        </mat-checkbox>
        <ng-container *ngIf="form.get('waitUntilEnabled')?.value">
          <automata-delay-control [form]="form" [sleep]="step?.sleep || 0"></automata-delay-control>
        </ng-container>
      </div>
    </glxy-form-field>

    <!-- Specific day of the month -->
    <glxy-form-field>
      <glxy-label
        ><strong>{{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.AND_THEN' | translate }}</strong></glxy-label
      >
      <mat-checkbox formControlName="monthDayEnabled">
        {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.WAIT_UNTIL_A_MONTH_DAY' | translate }}
        <extended>
          {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.DAY_EXPLANATION' | translate }}
        </extended>
      </mat-checkbox>
      <ng-container *ngIf="form.get('monthDayEnabled')?.value">
        <automata-monthday-selector
          [form]="form"
          [sleepMonthDays]="step?.sleepWaitConditions?.dayOfMonthSelection || []"
        ></automata-monthday-selector>
      </ng-container>
    </glxy-form-field>

    <!-- Day of the week -->
    <glxy-form-field>
      <glxy-label
        ><strong>{{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.AND_THEN' | translate }}</strong></glxy-label
      >
      <mat-checkbox formControlName="weekdayEnabled">
        {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.WAIT_UNTIL_A_WEEKDAY' | translate }}
        <extended>
          {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.DAY_EXPLANATION' | translate }}
        </extended>
      </mat-checkbox>
      <ng-container *ngIf="form.get('weekdayEnabled')?.value">
        <automata-weekday-selector
          [form]="form"
          [sleepWeekdays]="step?.sleepWaitConditions?.weekdaySelection || []"
        ></automata-weekday-selector>
      </ng-container>
    </glxy-form-field>

    <!-- Time within a range -->
    <glxy-form-field>
      <glxy-label
        ><strong>{{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.AND_THEN' | translate }}</strong></glxy-label
      >
      <mat-checkbox formControlName="timeRangeEnabled">
        {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.WAIT_UNTIL_TIME_IS_WITHIN_RANGE' | translate }}
        <extended>
          {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_RANGE_EXPLANATION' | translate }}
        </extended>
      </mat-checkbox>
      <ng-container *ngIf="form.get('timeRangeEnabled')?.value">
        <automata-time-range-slider
          [form]="form"
          [startHour]="step?.sleepWaitConditions?.timeRangeStartHour"
          [endHour]="step?.sleepWaitConditions?.timeRangeEndHour"
        ></automata-time-range-slider>
      </ng-container>
    </glxy-form-field>
  </form>
</div>
